import React from 'react';

import { Flex } from '@lightspeed/flame/Core';

import BannerOffendingRecordsCleaned from 'pages/views/reports/CustomerData/BannerOffendingRecordsCleaned';
import BannerOffendingRecordsDetected from 'pages/views/reports/CustomerData/BannerOffendingRecordsDetected/BannerOffendingRecordsDetected';
import BannerOffendingRecordsDetectedReports from 'pages/views/reports/CustomerData/BannerOffendingRecordsDetected/BannerOffendingRecordsDetectedReports';
import { StyledBanner } from 'pages/views/reports/CustomerData/CustomerData.style';
import { trackAnalyticsEvent } from 'root/apps/helpers/AnalyticsTracking';

const BannerContent = ({
  offendingRecordsCount = 0,
  isReportPage = false,
}: {
  offendingRecordsCount: number;
  isReportPage?: boolean;
}) => {
  const session = window.merchantos?.session;
  const isOwnerOrAdmin = Boolean(session?.hasRight?.('owner') || session?.hasRight?.('admin'));

  React.useEffect(() => {
    if (!isOwnerOrAdmin) return; // only track for Owner/Admin
    if (offendingRecordsCount === 0 && isReportPage) return; // no banner is shown, don't need to track
    if (window.lsCloud.Modules.hasModule('data.pan_detection.tracker')) {
      trackAnalyticsEvent({
        eventCategory: 'PAN',
        eventName: 'Report',
        eventAction: isReportPage ? 'ReportsPageBannerViewed' : 'Viewed',
        eventLabel: 'RecordsCount',
        eventValue: `${offendingRecordsCount}`,
      });
    }
  }, [offendingRecordsCount, isReportPage, isOwnerOrAdmin]);

  if (!isOwnerOrAdmin) {
    return null;
  }

  if (offendingRecordsCount === 0 && isReportPage) {
    return null;
  }

  if (offendingRecordsCount === 0) {
    return (
      <StyledBanner showBackground={true}>
        <Flex padding="20px" alignItems="center" height="100%">
          <BannerOffendingRecordsCleaned />
        </Flex>
      </StyledBanner>
    );
  }

  if (isReportPage) {
    return (
      <StyledBanner showBackground={true}>
        <Flex padding="20px" alignItems="center" height="100%">
          <BannerOffendingRecordsDetectedReports />
        </Flex>
      </StyledBanner>
    );
  }

  return (
    <StyledBanner showBackground={true}>
      <Flex padding="20px" alignItems="center" height="100%">
        <BannerOffendingRecordsDetected offendingRecordsCount={offendingRecordsCount} />
      </Flex>
    </StyledBanner>
  );
};

export default BannerContent;
